import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CustomValidator } from '../../shared/_validators/custom-validator';
import { DatacontextService } from '../../data/datacontext.service';
import { CommonNotificationService } from '../../shared/services/common-notification/common-notification.service';
import { AmplitudeLoggerService } from 'src/app/shared/services/amplitude-logger/amplitude-logger.service';
import { AnalyticsEvents } from 'src/app/shared/constants/analytics-events';
import { AppSelectorService } from 'src/app/shared/services/app-selector/app-selector.service';
import { AccountType, AccountTypeNameEnum, NetcoreUserEmailEnum } from "src/app/shared/enums/account-type.enum";
@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.scss']
})
export class AddUserComponent implements OnInit {
  public selectAccountType = [{ label: AccountTypeNameEnum.SSO, value: "1" },
  { label: AccountTypeNameEnum.INDIVIDUALACCOUNT, value: "0" }
  ];
  public addUserForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, CustomValidator.emailValidator, CustomValidator.emailSpecialCharValidator]),
    sso: new UntypedFormControl("1", [Validators.required]),
  });
  public btnPromise: any;
  private userList: any;
  public formBuildObj: any = {
    email: [null, [Validators.required, CustomValidator.emailValidator, CustomValidator.emailSpecialCharValidator]],
    sso: ["1", [Validators.required]],
  };
  public formControlsList: any = [];
  private userInfo: any;
  public emailExist = false;

  constructor(
    private dialogRef: MatDialogRef<AddUserComponent>,
    private appSelectorService: AppSelectorService,
    private formBuilder: UntypedFormBuilder,
    private datacontextService: DatacontextService,
    private commonNotificationService: CommonNotificationService,
    private amplitudeLoggerService: AmplitudeLoggerService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.createUserForm();
    this.fetchUserInfo();
    this.fetchUsers();
  }

  createUserForm() {
    this.addUserForm = this.formBuilder.group(this.formBuildObj);
  }

  trackClick() {
    const { eventName: { UM_INVITE }, eventAction: { INVITE_SUBMIT } } = AnalyticsEvents;
    this.amplitudeLoggerService.log(UM_INVITE, INVITE_SUBMIT, {
      email_invitee: this.addUserForm.value.email,
    });
  }

  addUserSubmit() {
    if (typeof this.data.companyId === 'undefined') {
      this.data.companyId = this.appSelectorService.getCompanyDetails()['id'];
    }
    this.trackClick();
    const payload = {
      emails: this.addUserForm.value.email.split(","),
      company_id: this.data.companyId,
      resendInvite: false,
      sso: parseInt(this.addUserForm.value.sso),
    };
    this.btnPromise = this.datacontextService.userManagement.
      inviteUsers(payload).subscribe((res: any) => {
        if (res.is_error) {
          this.commonNotificationService.showSnackBar(res.error_message, 'error', 2000);
          return;
        }
        const msg = `An invitation has been sent to ${this.addUserForm.value.email}`;
        this.commonNotificationService.showSnackBar(msg, 'success', 2000);
        this.dialogRef.close({ email: this.addUserForm.value.email });
      });
  }

  fetchUserInfo() {
    this.datacontextService.user.getUserInfo((res: any) => {
      if (res.api_response) {
        this.userInfo = res.api_response;
        var isNetcoreUser = this.userInfo.email.toLowerCase().includes(NetcoreUserEmailEnum.NETCORECLOUD_COM);
        var isHanselIOUser = this.userInfo.email.toLowerCase().includes(NetcoreUserEmailEnum.HANSEL_IO);
        if (!isNetcoreUser && !isHanselIOUser) {
          if (this.userInfo.sso === AccountType.INDIVIDUALACCOUNT) {
            let index = this.selectAccountType.findIndex((e) => parseInt(e.value) === AccountType.SSO);
            this.addUserForm.controls["sso"].setValue("0");
            this.selectAccountType.splice(index, 1);
          } else {
            let index = this.selectAccountType.findIndex((e) => parseInt(e.value) === AccountType.INDIVIDUALACCOUNT);
            this.selectAccountType.splice(index, 1);
          }
        }
      }
    });
  }

  validateEmail(email: string) {
    let index = this.userList.findIndex((e) => e.email === email);
    if (index !== -1) {
      this.emailExist = true;
    } else {
      this.emailExist = false;
    }
  }

  fetchUsers() {
    if (typeof this.data.companyId === 'undefined') {
      this.data.companyId = this.appSelectorService.getCompanyDetails()['id'];
    }
    const params = { company_id: this.data.companyId };
    this.datacontextService.userManagement.getUsers(params).subscribe((res: any) => {
      if (res.is_error === false && res.api_response) {
        this.userList = res.api_response.users;
      }
    });
  }
}
